module.exports = __webpack_public_path__ + "img/logo.95b0b5fa.png";